// UnitHydrographsAbstractionForm.jsx
import { Grid } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} target The name of the object targetted by this form.
 * @param {string} month name of the month for this unit hydrograph
 * @returns UI for interactive swmm modeling.
 */
export default function UnitHydrographsAbstractionForm({model, setModel, target, month}) {
  const objsIndexes = ['Short', 'Medium', 'Long']

  // When there is a change to an input element, modify the model.
  const updateValue = (val, type, varName) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ''

    if(model && model.HYDROGRAPHS && model.HYDROGRAPHS[target] && model.HYDROGRAPHS[target].Months[month]){
      setModel(prev => ({
        ...prev,
        HYDROGRAPHS:{
          ...prev.HYDROGRAPHS,
          [target]: {
            ...prev.HYDROGRAPHS[target],
            Months: {
              ...prev.HYDROGRAPHS[target].Months,
              [month]: {
                ...prev.HYDROGRAPHS[target].Months[month],
                [type]: {
                  ...prev.HYDROGRAPHS[target].Months[month][type],
                  [varName]: val
                }
              }
            }
          }
        }
      }))
    }
  }

  return(
    <>
    {
      model &&
      model.HYDROGRAPHS &&
      model.HYDROGRAPHS[target] &&
      model.HYDROGRAPHS[target].Months[month] &&
      <>
      <Grid container style={{fontSize: '12px'}}>
        <Grid item xs={6} style={{fontSize: '12px'}}>
          <div style={{borderBottom:'3px solid #fff'}}>Response</div>
          <label style={{height: '22px'}} className='editor-small'>Short-Term</label>
          <label style={{height: '22px'}} className='editor-small'>Medium-Term</label>
          <label style={{height: '22px'}} className='editor-small'>Long-Term</label>
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Dmax</div>
          {
            objsIndexes.map(v=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, v, 'Dmax')}}
                      value={model.HYDROGRAPHS[target].Months[month][v].Dmax}
                      id={'ClimatologyADCPer'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
              />
            )
          }
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>Drec</div>
          {
            objsIndexes.map(v=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, v, 'Drec')}}
                      value={model.HYDROGRAPHS[target].Months[month][v].Drec}
                      id={'ClimatologyADCPer'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
              />
            )
          }
        </Grid>
        <Grid item xs={2}>
          <div style={{borderBottom:'3px solid #fff'}}>D0</div>
          {
            objsIndexes.map(v=>
              <input  type = "number"
                      style={{width: '95%', display: 'flex'}}
                      onChange={(e)=>{updateValue(e.target.value, v, 'D0')}}
                      value={model.HYDROGRAPHS[target].Months[month][v].D0}
                      id={'ClimatologyADCPer'+v.toString()}
                      key={'ClimatologyADCImp'+v.toString()}
              />
            )
          }
        </Grid>
      </Grid>
      </>
    }
    </>
  )
}